// The pilot study task (PILOT_STUDY_TASK.md), kept as one paste-able block so
// a session can start in one click during testing and walkthroughs.
export const PILOT = `Create a tailored application package for an Applied Scientist role on a catalog intelligence team working on product identity, relationship inference, search and agentic shopping experiences.

The candidate is a late-stage PhD candidate whose research is AI systems for data, code and structured information, with experience in LLM-based generation, evaluation and human-AI interaction.

The package must include a cover letter and a short recruiter outreach email.
Cover letter: 350-500 words. Recruiter email: 100-150 words.
The final email must include a subject line.
Use the placeholders [Candidate Name], [University], [Advisor/Lab] and [Project/Paper Title] instead of real personal information.
The tone must be confident but not boastful.
The package must avoid vague phrases like "cutting-edge technology", "passionate innovator" or "game-changing AI".
Run the word-count check before declaring the package finished.`;

export default PILOT;
